import * as React from 'react';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import Can from '../../../components/Can';
import { useTranslation } from "react-i18next";
import SideBarMenuCollapseItem from '../SideBarMenuCollapseItem';
import SideBarSubMenuItem from '../SideBarSubMenuItem';
import { AbilityContext } from '../../../components/Can';

export default () => {
    const { t } = useTranslation();
    const ability = React.useContext(AbilityContext);

    if (ability.can("read", "Knowledge") || ability.can("read", "Accounting")) {
        return (
            <SideBarMenuCollapseItem icon={<ControlPointIcon />} type="extra" text={t("extra")}>
                <Can do="read" on='Knowledge'>
                    <SideBarSubMenuItem id="side_menu_item_knowledge" to="/knowledge" text={t("knowledge")} />
                </Can>
                <Can do="read" on='Accounting'>
                    <SideBarSubMenuItem id="side_menu_item_accounting" to="/accounting" text={t("accounting")} />
                </Can>
            </SideBarMenuCollapseItem>
        );
    } else return null;
}